module.exports = __webpack_public_path__ + "img/26.6c72c023.png";